/**
 * This class represents bootstrap carousel, which is carousel only on mobile
 */
import Helper from "../Helper";

export default class MobileCarousel {

    /**
     * Constructor of bootstrap carousel, which is carousel only on mobile
     * @param {String} id carousel element id
     */
    constructor(id)
    {
        this.carouselElement = document.querySelector('#'+id);
        this.carousel = undefined;

        this.init();
    }

    /**
     * Init function
     */
    init()
    {
        /**
         * On window resize check the window size and handle carousel accordingly
         */
        window.windowResizeObserve.register(() => {
            this.handleCarousel();
        });

        this.handleCarousel();
    }

    /**
     * Handle instanciating carousel
     */
    handleCarousel()
    {
        if (Helper.isMobileOrLower() && this.carousel === undefined) {
            this.carousel = new bootstrap.Carousel(this.carouselElement, {
                interval: 8000,
                ride: 'carousel',
                pause: false
            })

            this.carousel.cycle();
        } else if (!Helper.isMobileOrLower()) {
            if (this.carousel !== undefined) {
                this.carousel.dispose();
                this.carousel = undefined;
            }
        }
    }
}
